// Global Types
import { ResetStateAction } from 'services/auth/types';

// Global Constants
// @ts-ignore
import { SET_CURRENT_ORGANIZATION_ID } from 'services/currentOrganizationId/constants';
import { RESET_STATE } from 'services/auth/constants';

// Local Types
import {
    HarvestEventDocumentsState,
    HarvestEventDocumentsTypes
} from './types';

// Local Constants
import { HARVEST_EVENT_DOCUMENTS_SET } from './constants';

export const initialState: HarvestEventDocumentsState = {
    data: {}
};

export default function (
    state: HarvestEventDocumentsState = initialState,
    action: HarvestEventDocumentsTypes | ResetStateAction
): HarvestEventDocumentsState {
    switch (action.type) {
        case HARVEST_EVENT_DOCUMENTS_SET: {
            const { payload } = action;
            return {
                data: payload
            };
        }
        case SET_CURRENT_ORGANIZATION_ID:
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
